import React from 'react'

export default function ProductType() {
  return (
    <div className='d-flex flex-column align-items-center'>
      <h1>Product Types we offer:</h1>
      <p>Blush</p>
      <p>Bronzer</p>
      <p>Eyebrow</p>
      <p>Eyeliner</p>
      <p>Eyeshadow</p>
      <p>Foundation</p>
      <p>Lip liner</p>
      <p>Lipstick</p>
      <p>Mascara</p>
      <p>Nail Polish</p>
    </div>
  )
}
